export default "__VITE_ASSET__Bf2S$TLo__"